import React from 'react'
import {iconSize} from '../shared/styles'

const colors = ['#35bc9b', '#3337bb', '#a6a224', '#bb335f', '#bb3333', '#c99941']

const getInitials = (name) => {
    const names = name.split(' ').filter((word) => word.length > 0)
    const initials = (() => {
        switch (names.length) {
            case 0:
                return '__'
            case 1:
                if (name.trim().length === 1) {
                    return `${name}_`
                }
                return name.substring(0, 2)
            default:
                return names[0].charAt(0) + names[1].charAt(0)
        }
    })()
    return initials.toUpperCase()
}

const resizeFactor = 1 - 1 / 3

const UserWithoutPhotoIcon = ({name, size}) => {
    const initials = getInitials(name)
    const backgroundColor = colors[initials.charCodeAt(1) % 6]

    const customIcon = {
        container: {
            borderRadius: '50%',
            backgroundColor,
            padding: `${iconSize[size] / 6}px`,
            display: 'flex'
        },
        content: {
            color: '#fff',
            fontFamily: 'inherit',
            textAlign: 'center',
            fontSize: `${resizeFactor * iconSize[size]}px`,
            height: `${iconSize[size]}px`,
            width: `${iconSize[size]}px`,
            lineHeight: `${iconSize[size]}px`
        }
    }

    return (
        <div className="icon" style={customIcon.container}>
            <div style={customIcon.content}>{initials}</div>
        </div>
    )
}

export default UserWithoutPhotoIcon
